import ServiceResultFactory from '../../common/api/ServiceResultFactory';
import Request from '../../common/api/request';

const getProductsAndServices =
(baseApiUrl, eventEditionId, locale) => {
  const url = `${baseApiUrl}v1/event-editions/${eventEditionId}/products-services`;

  return Request
    .get(url)
    .then(response => ServiceResultFactory.fromSuccess(response.body))
    .catch(error => ServiceResultFactory.fromError(locale, error));
};

const deleteProductsAndServices = (baseApiUrl, eventEditionId, id, locale) => {
  const url = `${baseApiUrl}v1/event-editions/${eventEditionId}/products-services/${id}`;

  return Request
    .delete(url)
    .then(response => ServiceResultFactory.fromSuccess(response.body))
    .catch(error => ServiceResultFactory.fromError(locale, error));
};

const saveProductsAndServices = (baseApiUrl, eventEditionId, itemToSave, locale) => {
  const url = `${baseApiUrl}v1/event-editions/${eventEditionId}/products-services`;
  return Request
    .post(url, itemToSave)
    .then(response => ServiceResultFactory.fromSuccess(response.body))
    .catch(error => ServiceResultFactory.fromError(locale, error));
};

export default {
  getProductsAndServices,
  deleteProductsAndServices,
  saveProductsAndServices
};
